import axios from "axios";

let API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
let SECRET_KEY_WEBSERVICE = process.env.VUE_APP_SECRET_KEY_WEBSERVICE;
let TOKEN_PORTAL = process.env.VUE_APP_TOKEN_PORTAL;
let ID_PORTAL = process.env.VUE_APP_ID_PORTAL;

export default {
    /**
     * Carga info del portal del API y la guarda en el store.
     * @param commit commit
     */
    getPortalInfo({commit, state}) {
        return new Promise((resolve, reject) => {
            this._vm.$api.getPortalInfo()
                .then(data => {
                    // Pasar por categorías actuales, sobreescribir las que no hayan cargado contenido aún.
                    if (data.categorias) {
                        data.categorias = data.categorias.map(categoria => {
                            let catActual = state.portal.categorias.filter(cat => cat.id == categoria.id)
                            if (catActual.length > 0) {
                                // Ya la categoría está cargada, ver si ya cargó contenido.
                                if (!catActual[0].contenidosLoaded) {
                                    // No ha cargado, sobreescribir.
                                    return Object.assign(catActual[0], categoria)
                                } else {
                                    // Ya tiene contenido. sobreescribir todo menos contenido.
                                    return Object.assign(catActual[0], categoria, {
                                        contenidosLoaded: true,
                                        contenidos: catActual[0].contenidos
                                    })
                                }
                            }

                            // Por cada categoría, poner un array de contenidos (que se va a llenar por cada curso).
                            categoria.contenidos = []
                            categoria.contenidosLoaded = false
                            return categoria
                        })
                    }
                    commit('setPortalInfo', data)
                    resolve(data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error)
                })
        })
    },
    /**
     * Revisa si hay un cookie de usuario logueado válido y lo guarda en el store.
     * @param {commit} commit
     */
    getUserCookie({commit}) {
        commit('setIsLoadingCookie', true)
        return new Promise((resolve, reject) => {
            this._vm.$api.getUserCookie()
                .then(data => {
                    commit('setIsLoadingCookie', false)
                    commit('setDidLoadUser', true)
                    if (data.success) {
                        commit('setUserInfo', data.user)
                        resolve(data)
                    } else {
                        reject(data)
                    }
                })
                .catch(error => {
                    console.log(error)
                    commit('setIsLoadingCookie', false)
                    commit('setDidLoadUser', true)
                    reject(error)
                })
        })
    },

    /**
     * Envía login y password para autenticar usuario, si autentica, oculta el lightbox
     * y lo guarda en el store.
     * @param {commit} commit
     */
    login({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {

            if (typeof payload.telefono !== 'undefined' && payload.telefono != '') {
                this._vm.$api.login_telefono(payload.telefono, payload.validarEntrada)
                    .then(userInfo => {
                        commit('togglePortalLoginModal', false)
                        commit('setUserInfo', userInfo)
                        console.log('login')


                        // Cargar compras de usuario
                        dispatch('getUserComprasCache').catch(error => console.log('error getUserCgetUserComprasCacheompras', error))


                        // Cargar compras de usuario
                        dispatch('getUserCompras').catch(error => console.log('error getUserCompras', error))

                        // Cargar videos de usuario
                        dispatch('getUserVideos').catch(error => console.log('error getUserVideos', error))
                        if (payload.validarEntrada != "CHECKOUT") {
                            dispatch('checkUserActivado')
                        }
                        resolve(userInfo)
                    })
                    .catch(error => {
                        reject(error)
                    })
            } else {
                this._vm.$api.login(payload.email, payload.password)
                    .then(userInfo => {
                        commit('togglePortalLoginModal', false)
                        commit('setUserInfo', userInfo)
                        console.log('login')

                        // Cargar compras de usuario
                        dispatch('getUserComprasCache').catch(error => console.log('error getUserCgetUserComprasCacheompras', error))

                        // Cargar compras de usuario
                        dispatch('getUserCompras').catch(error => console.log('error getUserCompras', error))

                        // Cargar videos de usuario
                        dispatch('getUserVideos').catch(error => console.log('error getUserVideos', error))

                        if (payload.validarEntrada != "CHECKOUTPRESOLD") {
                            dispatch('checkUserActivado')
                        }

                        resolve(userInfo)
                    })
                    .catch(error => {
                        reject(error)
                    })
            }

        })
    },

    logout({commit}) {
        return new Promise((resolve, reject) => {
            this._vm.$api.logout()
                .then(response => {
                    commit('removeUser')
                    resolve(response)
                })
                .catch(error => {
                    console.log('logout error', error)
                    reject(error)
                })
        })
    },

    updateUser({commit}, user) {
        return new Promise((resolve, reject) => {
            this._vm.$api.updateUser(user)
                .then(response => {
                    commit('updateUser', response.data.user)
                    resolve(response.data)
                })
                .catch(error => {
                    console.log('logout error', error)
                    reject(error)
                })
        })
    },

    updateUserPhoto({commit}, file) {
        return new Promise((resolve, reject) => {
            this._vm.$api.updateUserPhoto(file)
                .then(response => {
                    console.log('update photo', response)
                    if (response.data.response == '200') {
                        // Actualizar foto de usuario
                        commit('updateUser', {
                            foto: response.data.foto
                        })
                    }
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    getCategoriaContenido({commit}, id_categoria) {
        return new Promise((resolve, reject) => {
            this._vm.$api.getCategoriaContenido(id_categoria)
                .then(response => {
                    // Actualizar contenidos de la categoria
                    commit('setCategoriaContenidos', {
                        id_categoria,
                        contenidos: response.data.contenidos
                    })
                    resolve(response.data.contenidos)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },


    getUserCompras({commit}) {
        return new Promise((resolve, reject) => {
            this._vm.$api.getUserCompras()
                .then(response => {
                    //console.log('usercompras', response)
                    // Actualizar contenidos de la categoria
                    commit('setUserCompras', {
                        mis_compras: response.data.data.mis_compras || [],
                        mis_compras_moviles: response.data.data.mis_compras_moviles || [],
                        mis_compras_pendientes: response.data.data.mis_compras_pendientes || [],
                        mis_compras_regaladas: response.data.data.mis_compras_regaladas || [],
                        mis_compras_app: response.data.data.mis_compras_app || [],
                        mis_regalos: response.data.data.mis_regalos || [],
                        all_access: response.data.data.all_access || []
                    })
                    commit('updateUser', {
                        all_access_active: response.data.data.all_access_active
                    })
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },


    getUserComprasCache({commit}) {
        return new Promise((resolve, reject) => {
            this._vm.$api.getUserComprasCache()
                .then(response => {
                    //console.log('usercompras', response)
                    // Actualizar contenidos de la categoria
                    commit('setUserCompras', {
                        mis_compras: response.data.data.mis_compras || [],
                        mis_compras_moviles: response.data.data.mis_compras_moviles || [],
                        mis_compras_pendientes: response.data.data.mis_compras_pendientes || [],
                        mis_compras_regaladas: response.data.data.mis_compras_regaladas || [],
                        mis_compras_app: response.data.data.mis_compras_app || [],
                        mis_regalos: response.data.data.mis_regalos || [],
                        all_access: response.data.data.all_access || []
                    })
                    commit('updateUser', {
                        all_access_active: response.data.data.all_access_active
                    })
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },


    getUserVideos({commit, state}) {
        return new Promise((resolve, reject) => {
            this._vm.$api.getUserVideos()
                .then(response => {
                    //console.log('uservideos action', response.data)
                    //console.log('videos actuales', state.user.videos)
                    // Actualizar contenidos de la categoria
                    commit('setUserVideos', {
                        videos: [...state.user.videos].concat(response.data.videos || [])
                    })
                    commit('setDidLoadUserVideos', true)
                    resolve(response.data.videos)
                })
                .catch(error => {
                    commit('setDidLoadUserVideos', true)
                    reject(error)
                })
        })
    },

    videoProgreso({commit}, payload) {
        return new Promise((resolve, reject) => {
            console.log('action', {
                id_contenido_video: payload.id_contenido_video,
                progreso: payload.progreso
            })
            this._vm.$api.videoProgreso(payload.id_contenido_video, payload.progreso)
                .then(response => {
                    console.log('videoprogreso', response.data)
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Almacena informacion de compra por landing de operador movistar
     * Recibe los parametros
     * Devuelve
     */
    landingPreWork({dispatch}, preWorkData) {
        return new Promise((resolve, reject) => {
            this._vm.$api.landingPreWork(preWorkData).then(response => {

                if (response.data.response == "200") {
                    resolve(response.data);
                } else {
                    reject(response);
                }
            }).catch(error => {
                reject(error);
            })
        })
    },

    /**
     * Registrar un nuevo usuario.
     * @param {commit} commit
     */
    registro({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            this._vm.$api.registro2(payload)
                .then(response => {
                    if (response.data.success) {
                        resolve(response.data)
                    } else {
                        reject(response.data)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Ubica el video y actualiza el progreso en el store.
     * @param video
     * @param progreso
     */
    updateProgreso({state, commit}, payload) {
        // Ver si tiene all_access
        if ('all_access' in state.user) {
            let aavideo = state.user.all_access.find(v => v.id_contenido_video == payload.video.id)
            console.log({
                aavideo
            })
            if (aavideo) {
                // Actualizar en all_access
                commit('updateUser', {
                    all_access: state.user.all_access.map(v => {
                        if (v.id_contenido_video == payload.video.id) {
                            v.progreso = parseInt(payload.progreso)
                        }
                        return v
                    })
                })
            }
        }
        // Actualizar array de videos
        if ('videos' in state.user) {
            let vvideos = state.user.videos.find(v => v.id == payload.video.id)
            if (vvideos) {
                console.log({
                    vvideos
                })
                // Actualizar (o crear) el array de progreso.
                let progresoArray = []
                if ('compras_productos_categoria_video_progreso' in vvideos) {
                    if (vvideos.compras_productos_categoria_video_progreso.length > 0) {
                        progresoArray = [...vvideos.compras_productos_categoria_video_progreso]
                        progresoArray[0].progreso = parseInt(payload.progreso)
                    }
                }
                if (!!progresoArray) {
                    progresoArray = [{
                        id: payload.video.id,
                        progreso: parseInt(payload.progreso),
                        id_user: state.user.id,
                        id_contenido_video: payload.video.id
                    }]
                }

                console.log({
                    progresoArray
                })

                // Actualizar array de videos
                commit('updateUser', {
                    videos: state.user.videos.map(v => {
                        if (v.id == payload.video.id) {
                            v = {
                                ...v,
                                compras_productos_categoria_video_progreso: progresoArray
                            }
                        }
                        return v
                    })
                })

            }
        }
    },
    checkUserActivado(context, routeName) {
        let inactivo = !context.getters.userActivado &&
            ![
                "perfil",
                "olvido_password",
                "restablecer_password",
                "logout",
                "activar_usuario",
                "checkout",
                "CheckoutAlreadySoldLanding",
            ].includes(routeName)

        if (context.state.user.email.includes("phone_")) {
            inactivo = false;
        }

        //Se comenta y evita aparacion del modal para completar datos del perfil
        /*
        context.commit(
            "toggleCompletarPerfilModalVisible",
            inactivo
        );*/


        return !inactivo
    },
    transferencia({state, commit}, payload) {
        return new Promise((resolve, reject) => {
            this._vm.$api.verificar_compra_pendiente(payload.id_compra, payload.numero, payload.nombre, payload.banco)
                .then(response => {
                    console.log('transferencia action response', response)
                    if (response.data.response.toLowerCase().indexOf("transferencia/checkout/aprobada/") >= 0) {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    cencosud({state, commit}, payload) {
        return new Promise((resolve, reject) => {
            this._vm.$api.verificar_compra_pendiente(payload.id_compra, payload.codigo, payload.rut, "cencosud")
                .then(response => {
                    console.log('cencosud action response', response)
                    if (response.data.response.toLowerCase().indexOf("cencosud/checkout/aprobada/") >= 0) {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    eventKlaviyo({state, commit}, payload) {
        return new Promise((resolve, reject) => {

            this._vm.$api.setKlaviyoApi(payload)
                .then(response => {

                    //console.log("Klaviyo ",response)

                })
                .catch(error => {
                    //console.log(error);
                });
        })
    },
}
